import { useMemo, useState, useCallback } from 'react';

interface UseServerPaginationProps {
  initialItemsPerPage?: number;
  initialPage?: number;
}

// interface UseServerPaginationReturn {
//   currentPage: number;
//   itemsPerPage: number;
//   handlePageChange: (page: number) => void;
//   handleItemsPerPageChange: (itemsPerPage: number) => void;
//   goToFirstPage: () => void;
//   goToLastPage: () => void;
//   goToNextPage: () => void;
//   goToPreviousPage: () => void;
//   canGoToNextPage: boolean;
//   canGoToPreviousPage: boolean;
//   // API params for server-side pagination
//   apiParams: {
//     page: number;
//     limit: number;
//   };
// }

export function useServerPagination({ initialItemsPerPage = 10, initialPage = 1 }: UseServerPaginationProps = {}) {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((newItemsPerPage: number) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when changing limit
  }, []);

  const goToFirstPage = useCallback(() => {
    setCurrentPage(1);
  }, []);

  const goToLastPage = useCallback((totalPages: number) => {
    setCurrentPage(totalPages);
  }, []);

  const goToNextPage = useCallback(
    (totalPages: number) => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    },
    [currentPage]
  );

  const goToPreviousPage = useCallback(() => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }, [currentPage]);

  const canGoToNextPage = useCallback(
    (totalPages: number) => {
      return currentPage < totalPages;
    },
    [currentPage]
  );

  const canGoToPreviousPage = currentPage > 1;

  const apiParams = useMemo(
    () => ({
      page: currentPage,
      limit: itemsPerPage,
    }),
    [currentPage, itemsPerPage]
  );

  return {
    currentPage,
    itemsPerPage,
    handlePageChange,
    handleItemsPerPageChange,
    goToFirstPage,
    goToLastPage,
    goToNextPage,
    goToPreviousPage,
    canGoToNextPage,
    canGoToPreviousPage,
    apiParams,
  };
}
